<template>
  <div>
    <div class="tabs is-fullwidth is-centered">
      <ul>
        <li
          v-bind:key="tab.name"
          v-for="tab in tabs"
          :class="{ 'is-active': tab.isActive }"
        >
          <a @click="selectTab(tab)">{{ tab.name }}</a>
        </li>
      </ul>
    </div>

    <div class="tabs-details">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'tabs',
  data() {
    return {
      tabs: [],
    };
  },
  created() {
    this.tabs = this.$children;
  },
  methods: {
    selectTab(selectedTab) {
      this.tabs = this.tabs.map((tab) => {
        tab.isActive = tab.name === selectedTab.name; // eslint-disable-line
        return tab;
      });
    },
  },
};
</script>
<style scoped>
a {
  cursor: pointer;
}
.tabs {
  -webkit-overflow-scrolling: touch;
  align-items: stretch;
  display: flex;
  font-size: 1rem;
  justify-content: space-between;
  overflow: hidden;
  overflow-x: auto;
  white-space: nowrap;
}

.tabs a {
  align-items: center;
  border-bottom-color: #dbdbdb;
  border-bottom-style: solid;
  border-bottom-width: 2px;
  color: #4a4a4a;
  display: flex;
  justify-content: center;
  margin-bottom: -1px;
  padding: 0.5em 1em;
  vertical-align: top;
  text-decoration: none;
  font-size: 13px;
  cursor: 'pointer';
}

.tabs a:hover {
  border-bottom-color: #363636;
  color: #363636;
  cursor: 'pointer';
}

.tabs li {
  display: block;
}

.tabs li.is-active a {
  border-bottom-color: #00788d;
  color: #00788d;
}

.tabs ul {
  align-items: center;
  border-bottom-color: #dbdbdb;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  display: flex;
  flex-grow: 1;
  flex-shrink: 0;
  justify-content: flex-start;
  padding: 0;
}

.tabs.is-fullwidth li {
  flex-grow: 1;
  flex-shrink: 0;
}

.tabs.is-centered ul {
  justify-content: center;
}
</style>


// WEBPACK FOOTER //
// Tabs.vue?0eb61472